var map = {
	"./amsa/stages": [
		"Swum",
		0,
		14
	],
	"./collahuasi/stages": [
		"Y2hI",
		0,
		13
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "gRYr";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages/cataloger lazy ^\.\/.*\/stages$
// module id = gRYr
// module chunks = 41